/**
 * Created by hp on 2017/8/16.
 */
import React, {Component} from 'react';
import qr from 'qr-encode';
import CloseImg from '../../images/qrcode-xzs-close.png';
import '../../css/common/AideCard.css';

class AideCard extends Component {
    constructor () {
        super();
        this.handleCloseCard = this.handleCloseCard.bind(this);
        this.handleGetKey = this.handleGetKey.bind(this);

        this.AIDE_CARD_KEY = 'wkAideCard-';
        this.state = {
            show: true
        }
    }

    handleGetKey() {
        let date = new Date(),
            month = date.getMonth() + 1,
            day = date.getDate();
        return this.AIDE_CARD_KEY + month +day;
    }

    handleCloseCard() {
        this.setState({show: false});
        let key = this.handleGetKey();
        localStorage.setItem(key, true);
        localStorage.wkAideCardCloseNum = localStorage.wkAideCardCloseNum ? parseInt(localStorage.wkAideCardCloseNum, 10) + 1 : 1;
    }

    componentWillMount() {
        let key = this.handleGetKey();
        if (localStorage.getItem(key) || parseInt(localStorage.wkAideCardCloseNum, 10) >= 2) {
            this.setState({show: false});
        }
    }

    render() {
        const {show} = this.state;
        const {mgTop, mgBottom, qrcode} = this.props;
        if (!show) {
            return null;
        }

        return(
            <div className="aide-card" style={{marginTop: (mgTop || 0) + 'px', marginBottom: (mgBottom || 0) + 'px'}}>
                <div className="aide-card-container">
                    <div className="aic-img">
                        <div className="qrcode">
                            <img src={qr(qrcode)} alt=""/>
                        </div>
                    </div>
                    <div className="aic-desc">
                        <p>长按扫码关注<span>“微课大学”</span></p>
                        {/* <p className="middle">专为讲师服务的公众号</p> */}
                        <p>加入月入10万讲师团</p>
                    </div>

                    <span className="aic-close" onClick={this.handleCloseCard}>
                        <img src={CloseImg} alt=""/>
                    </span>
                </div>
            </div>
        )
    }
}

export default AideCard;


// WEBPACK FOOTER //
// ./src/components/common/AideCard.js